// src/pages/NotFound.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StatusBar from '../components/BBS/StatusBar';

const CORRUPTION_MESSAGES = [
  'SECTOR NOT FOUND',
  'DATA CORRUPTED AT ADDRESS 0x████',
  'THE SIGNAL DOES NOT REACH HERE',
  'THIS PATH WAS ERASED',
  'NOTHING EXISTS IN THIS SECTOR ANYMORE',
  'YOU SHOULD NOT BE HERE',
  'TURN BACK',
];

export default function NotFound() {
  const navigate = useNavigate();
  const [message] = useState(
    CORRUPTION_MESSAGES[Math.floor(Math.random() * CORRUPTION_MESSAGES.length)]
  );
  const [flicker, setFlicker] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (Math.random() < 0.3) {
        setFlicker(true);
        setTimeout(() => setFlicker(false), 100);
      }
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      textAlign: 'center',
      padding: '80px 20px',
      minHeight: '100vh',
      opacity: flicker ? 0.3 : 1,
      transition: 'opacity 0.05s',
    }}>
      <div style={{
        fontSize: '4rem',
        color: '#ff0040',
        marginBottom: '20px',
        textShadow: '0 0 20px rgba(255, 0, 64, 0.5)',
      }}>
        404
      </div>

      <div style={{
        color: '#ff0040',
        fontSize: '1.3rem',
        marginBottom: '10px',
        letterSpacing: '3px',
      }}>
        ▓▓▓ {message} ▓▓▓
      </div>

      <div style={{ color: '#555', marginBottom: '30px' }}>
        The requested node does not exist in the circuit.
      </div>

      <button className="bbs-button" onClick={() => navigate('/')}>
        RETURN TO TERMINAL
      </button>

      <StatusBar />
    </div>
  );
}